namespace Vit {
    export class SergenManager {
        requestQueueDictionary: { [id: string]: RequestData; } = {};
        requestQueue: RequestData[] = [];
        private sergenInfos: SergenUIInfo[] = [];
        private sergenInfoDictionary: { [id: string]: SergenUIInfo; } = {};
        private mainNode: SergenDataNode;
        private globalNode: SergenGlobalNode;
        private global: GlobalModuleModel;
        private saveList: SergenUIInfo[];

        private constructor(public connection: string, private mainSergenInfo: SergenUIInfo) {
            this.sergenInfos.push(mainSergenInfo);
            this.sergenInfoDictionary[mainSergenInfo.Name] = mainSergenInfo;
        }

        private static _current: SergenManager;

        static get current(): SergenManager {
            return this._current;
        }

        get TableName(): string {
            return this.mainSergenInfo.DefaultForm.Name;
        }

        private _nodes: SergenNodeBase[];

        get nodes(): SergenNodeBase[] {
            return this._nodes;
        }

        get SergenUIInfos(): SergenUIInfo[] {
            return this.sergenInfos;
        }

        public static Create(connection: string, sergenInfo: SergenUIInfo): SergenManager {
            SergenNodeBase.Reset();
            this._current = new SergenManager(connection, sergenInfo);
            this._current.global = sergenInfo.GLobals;

            this._current.mainNode = new SergenDataNode(sergenInfo);
            this._current.globalNode = new SergenGlobalNode(sergenInfo.GLobals);
            this._current._nodes = [this._current.globalNode, this._current.mainNode];

            return this._current;
        }

        getSergenInfo(id: string): SergenUIInfo {
            return this.sergenInfoDictionary[id];
        }

        loadDetailTable(detailTableName: string, onload?: (s: SergenUIInfo) => void) {
            if (this.sergenInfoDictionary[detailTableName]) {
                if (onload) {
                    onload(this.sergenInfoDictionary[detailTableName]);
                }

                return;
            }

            if (this.requestQueueDictionary[detailTableName]) {
                this.requestQueueDictionary[detailTableName].onload.push(onload);
                return;
            }

            var rq = { tableName: detailTableName, onload: [onload] };
            this.requestQueueDictionary[detailTableName] = rq;
            this.requestQueue.push(rq);

            if (this.requestQueue.length == 1) {
                this.sendRequest(this.requestQueue[0].tableName);
            }
        }

        sendRequest(detailTableName: string) {
            SergenService.ListUIs({
                ConnectionKey: this.connection,
                TableKey: detailTableName,
            }, (response) => {
                response.Name = detailTableName;

                this.sergenInfos.push(response);
                this.sergenInfoDictionary[response.Name] = response;
                this._nodes.push(new SergenDataNode(response));

                var rq = this.requestQueueDictionary[detailTableName];

                for (var ol of rq.onload)
                    if (ol) {
                        ol(response);
                    }

                delete this.requestQueueDictionary[detailTableName];
                this.requestQueue.splice(0, 1);

                if (this.requestQueue.length > 0) {
                    this.sendRequest(this.requestQueue[0].tableName);
                }
            });
        }

        public save(onSucceed: () => void, onError: (error: string) => void) {
            this.saveList = [];

            for (var item of this.sergenInfos) {
                this.saveList.push(item);
            }

            this.saveGlobals(() => {
                this.saveListItems(onSucceed, onError);
            }, (e) => {
                onError(e);
            });
        }

        public GetEnums(plusItems?: ILookupKeyValue[]): ILookupKeyValue[] {
            var list: ILookupKeyValue[] = [];

            for (var item of this.global.Enums) {
                list.push({ key: item.Name, value: item.Name })
            }

            if (plusItems) {
                for (var pitem of plusItems) {
                    list.push({ key: pitem.key, value: pitem.value });
                }
            }

            return list;
        }

        private saveGlobals(onSucceed: () => void, onError: (error: string) => void) {
            SergenService.SaveGlobals({
                ConnectionKey: this.connection,
                Model: JSON.stringify(this.mainSergenInfo.GLobals),
            }, r => {
                if (onSucceed) {
                    onSucceed();
                }
            });
        }

        private saveListItems(onSucceed: () => void, onError: (error: string) => void) {
            if (this.saveList.length == 0) {
                if (onSucceed) {
                    onSucceed();
                }

                return;
            }

            var item = this.saveList[0];
            this.saveList.splice(0, 1);
            this.saveItem(item, () => {
                this.saveListItems(onSucceed, onError);
            }, onError);
        }

        private saveItem(item: SergenUIInfo, onSucceed: () => void, onError: (error: string) => void) {
            SergenService.SaveUIs({
                ConnectionKey: this.connection,
                TableKey: item.Name,
                Model: JSON.stringify(item),
            }, r => {
                if (onSucceed) {
                    onSucceed();
                }
            });
        }

        public GetLookups(schema: string, table: string): string[] {
            var list = [];

            for (var item of this.global.Lookups) {
                if (item.SchemaName == schema && item.TableName == table)
                    list.push(item.Lookup.Name + Globals.LookupEditorName);
            }
            return list;
        }
        public GetLookupsByDataType(dataType: string): string[] {
            var list = [];

            for (var item of this.global.Lookups) {
                if (item.PKType == dataType)
                    list.push(item.Lookup.Name + Globals.LookupEditorName);
            }
            return list;
        }

        public GetColumns(): ILookupKeyValue[] {
            var coulmns: ILookupKeyValue[] = [];
            for (var column of this.mainSergenInfo.DefaultGrid.Fields) {
                coulmns.push({ key: column.Name, value: column.Name });
            }
            return coulmns;
        }
    }

    interface RequestData {
        tableName: string;
        onload: ((s: SergenUIInfo) => void)[]
    }

    export class Globals {
        public static LookupEditorName: string = "LookupEditor";
    }
}